import {
  AuthenticationActionTypes,
  CREATE_USER,
  UPDATE_USER_ADDITIONAL_DETAILS,
  LOGOUT_USER,
  LOADING,
  UPDATE_USER_PREMIUM_STATUS,
} from '../models/action';
import { User } from '../models/store';

function reducer(state: User | null = null, action: AuthenticationActionTypes): User | null {
  switch (action.type) {
    case CREATE_USER:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_USER_PREMIUM_STATUS:
      return {
        ...state,
        premium: action.payload,
      };
    case UPDATE_USER_ADDITIONAL_DETAILS:
      return {
        ...state,
        ...action.payload,
      };
    case LOGOUT_USER:
      return {
        isAuthenticated: false,
        syncedWithDb: true,
        premium: false,
      };
    case LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
}

export default reducer;
